import { useCallback } from 'react';
import { debounce } from 'lodash';
import { isValidPodcast } from '../util';
import routes from '../../config/routes';

const useDebouncedFetch = (apiUrlProps, onError = () => {}, onSuccess = () => {}) => {
  const fetchPodcast = async rssFeedUrl => {
    const { env, limit } = apiUrlProps;
    const rssDomain = routes[env] || '';
    const url = `${rssDomain}/v1/get-podcast-feed?feedUrl=${encodeURIComponent(
      rssFeedUrl
    )}&limit=${limit}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (!isValidPodcast(data)) {
        onError(data);
      } else {
        onSuccess(data);
      }
    } catch (err) {
      onError(err);
    }
  };

  return useCallback(debounce(fetchPodcast, 1000, { trailing: true }), []);
};

export default useDebouncedFetch;
